let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("K5X5J")).then(() => parcelRequire('aJyzh'));